<template>
  <div class="favorites">
    <div v-if="loading" class="loading-overlay">
      <!-- 전역 로딩바 아래에 css도 추가됨-->
      <img src="@/assets/img/loadingbar.png" alt="loading" />
    </div>

    <div class="favorites-title" v-if="isAside">
      <div class="title">
        <icon-favorites /><!--타이블 즐겨찾기-->
        <span>{{ $t("button.favorite") }}</span>
        <button class="btn-refresh" @click="loadFetchFavorites">
          <icon-refresh />
        </button>
      </div>
      <span
        class="material-symbols-outlined"
        style="cursor: pointer"
        :disabled="cancelDisabled || loading"
        @click="onCancel"
        >close</span
      >
    </div>
    <div class="favorites-header">
      <div class="flex-l">
        <button
          class="btn-fold-add"
          :disabled="!selectedFavorite || folderPath.includes('모든 제약사')"
          :style="{
            color: selectedFavorite && !folderPath.includes('모든 제약사') ? '#174fdc' : '#d3d3d3',
          }"
          @click="onClickAddFolder"
        >
          <icon-folder-add /> {{ $t("button.add_folder2") }}
          <!--폴더추가-->
        </button>
        <!--폴더 추가-->
        <button
          class="btn-favorite-add"
          :disabled="!menuType || folderPath?.includes('모든 제약사')"
          :style="{
            color: menuType && !folderPath?.includes('모든 제약사') ? '#343434' : '#d3d3d3',
          }"
          @click="onClickAddFavorite"
        >
          <icon-favorites /> {{ $t("button.add_favorites") }}
          <!--즐겨찾기 추가-->
        </button>
        <!--즐겨찾기 추가-->
      </div>

      <!-- 검색창 -->
      <div class="search-wrap">
        <input
          type="text"
          :placeholder="$t('message.validation_empty')"
          v-model="searchKeyword"
          @keydown.enter="searchFavorite()"
        />
        <button class="btn-search-delete" v-if="searchKeyword.length > 0" @click="clearSearch">
          <icon-search-delete />
        </button>
        <button class="btn-search" v-else @click="searchFavorite()">
          <icon-search />
        </button>
      </div>
    </div>
    <div class="favorites-body">
      <div class="favorites-path">
        <!-- 검색 결과가 있을 경우 표시 -->
        <div class="left-col" v-if="!isSearch && (!searchFavoriteList || !searchFolderList)">
          <span class="path-label" v-for="(path, i) in folderPath.filter((p) => p !== 'root')" :key="path">
            <em>
              <!-- {{ path }} -->
              {{ path.length > 20 ? path.substring(0, 20) + "..." : path }}
            </em>
            <icon-arrow-right v-if="i !== folderPath.filter((p) => p !== 'root').length - 1" />
            <!-- 조건에따라 마지막 '>' 제거 -->
          </span>
        </div>
        <span v-else>검색 결과</span>

        <!-- 도움말 툴팁 내용 -->
        <div class="favorites-guide">
          <button @click="isFavoritesGuideTooltip = !isFavoritesGuideTooltip">
            <icon-info /> {{ $t("button.favorite_help") }}
            <!--도움말-->
          </button>

          <div class="favorites-guide-tooltip" v-if="isFavoritesGuideTooltip">
            <button class="btn-fqt-close" @click="isFavoritesGuideTooltip = !isFavoritesGuideTooltip">
              <icon-delete />
            </button>
            <p class="text" v-html="$t('message.favorites_help_info')"></p>
          </div>
        </div>
      </div>

      <div class="favorites-div2">
        <!-- 왼쪽 열: 폴더 구조 표시 -->
        <div class="left-col">
          <!-- 폴더 목록 표시 -->
          <empty-text
            v-if="isSearch && searchFolderList && searchFolderList.size === 0"
            text="폴더 검색 결과가 없습니다"
          />
          <div class="folder-list" v-else>
            <FavoriteTree
              v-bind:dept="0"
              v-bind:children="favoriteData[-1]"
              v-bind:selectedFavorite="selectedFavorite"
              @changeSelectedFavorite="changeSelectedFavorite"
            />
          </div>
        </div>

        <div class="right-col">
          <!-- 오른쪽 열: 즐겨찾기 목록 표시 -->
          <empty-text
            v-if="isSearch && searchFavoriteList && searchFavoriteList.size === 0"
            text="즐겨찾기 검색 결과가 없습니다"
          />
          <div class="bookmark-list">
            <!-- 1.선택된 즐겨찾기 폴더안에 즐겨찾기가 없을때 -->
            <div
              v-if="(!selectedFavorite || !selectedFavorite.children?.favorite?.length) && searchFavoriteList == null"
              class="no-favorites"
              :style="{ color: '#a9a9a9' }"
            >
              <span>( {{ $t("label.none") }} ) </span>
            </div>

            <!-- 2.선택된 즐겨찾기 폴더안에 즐겨찾기가 있을때 -->
            <div v-else>
              <div
                class="bookmark-items"
                v-for="(bookmark, index) in selectedFavorite
                  ? selectedFavorite?.children?.favorite || []
                  : searchFavoriteList"
                :key="bookmark.id"
                :style="{
                  'border-top': overFavorite === bookmark ? '2px solid #000' : 'none',
                }"
                :draggable="!bookmark.isEdit"
                @click="selectBookmark(bookmark)"
                @dragstart.stop="bookmarkDragStart($event, bookmark)"
                @dragover.stop="bookmarkDragOver($event, bookmark)"
                @dragleave="bookmarkDragLeave($event, bookmark)"
                @drop.stop="bookmarkDrop($event, bookmark)"
                @dblclick.stop="onClickOpenInNewTab(bookmark)"
                @mouseenter="handleMouseEnter(bookmark.id)"
                @mouseleave="handleMouseLeave"
              >
                <div
                  class="bookmark-path"
                  v-if="bookmark.path && searchFavoriteList"
                  :title="bookmark.path.join(' > ')"
                >
                  <template v-for="(p, i) in bookmark.path.filter((p) => p !== 'root')" :key="i">
                    <span>{{ p }}</span>
                    <icon-arrow-right v-if="i !== bookmark.path.filter((p) => p !== 'root').length - 1" />
                  </template>
                </div>

                <div class="bookmark-item" :class="{ active: selectedBookmark === bookmark }">
                  <span class="round-label" :style="getFavoriteIconColor(bookmark.serviceCode)">{{
                    getFavoriteIconName(bookmark.serviceCode)
                  }}</span>

                  <FavoriteInput
                    v-if="bookmark.isEdit"
                    v-bind:favorite="bookmark"
                    @lockSave="cancelDisabled = true"
                    @triggerSave="onSave"
                    :placeholder="$t('label.input_favorite_name')"
                    :isDeleting="isDeleting"
                  />
                  <strong class="label" v-else-if="selectBookmark === bookmark">{{ bookmark.title }}</strong>
                  <span class="label" v-else>{{ bookmark.title }}</span>

                  <!-- 즐겨찾기추가 삭제 버튼 추가 -->
                  <button
                    v-if="bookmark.id == null"
                    class="btn-delete-inline"
                    @mousedown.stop="handleDeleteClick(bookmark)"
                    :title="$t('button.delete')"
                    style="margin-left: 8px"
                  >
                    ⛌
                  </button>

                  <button
                    class="btn-more"
                    @click.stop="toggleBookmarkMore(bookmark)"
                    v-if="!isChildOfForbiddenFolder(bookmark)"
                  >
                    <icon-more />
                  </button>

                  <div
                    class="more-menu"
                    :style="{
                      zIndex: bookmark.isEdit ? 1 : 50,
                    }"
                    v-if="bookmark.id !== null && isBookmarkMore === bookmark.id"
                    @click.stop="toggleBookmarkMore(bookmark)"
                  >
                    <ul>
                      <li
                        v-if="!bookmark.isFolder && bookmark.id"
                        style="border-bottom: 1px solid #ddd"
                        @click.stop="onClickOpenInNewTab(bookmark)"
                      >
                        <button>{{ $t("button.favorite_open") }}</button>
                        <!--열기-->
                      </li>
                      <li
                        v-if="!bookmark.isFolder && bookmark.id"
                        style="border-bottom: 1px solid #ddd"
                        @click.stop="onClickAddModify(bookmark)"
                      >
                        <button>{{ $t("button.rename") }}</button>
                        <!--이름 바꾸기-->
                      </li>
                      <li v-if="!bookmark.isFolder && bookmark.id" @click.stop="deleteItemSelected(bookmark)">
                        <button class="btn-delete">
                          {{ $t("button.delete") }}
                        </button>
                        <!--삭제-->
                      </li>
                    </ul>
                  </div>

                  <div
                    class="bookmark-hover"
                    :class="{
                      'last-bookmark-hover': isFullList && bookmark.id === lastBookmark?.id,
                    }"
                    v-if="hoveredBookmark === bookmark.id"
                  >
                    <dl>
                      <dt>{{ bookmark.title }}</dt>
                      <dd v-if="bookmark.overview" v-html="bookmark.overview"></dd>
                      <!-- <dd v-else-if="bookmark.overview && bookmark.id === -1" style="color: red; font-weight: bold;"> &lt;!저장이 필요합니다 <br><br>저장을 누르세요 &gt; </dd>  -->
                      <dd v-else>-</dd>
                    </dl>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- END right-col -->
      </div>
      <!-- END favorites-div2 -->

      <div class="favorites-btn-wrap">
        <button class="btn-outline" :disabled="cancelDisabled || loading" @click="onCancel">
          {{ $t("button.cancel") }}
        </button>

        <button class="btn-primary" :disabled="loading" @click="onSave">
          {{ $t("button.save") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { nextTick } from "vue";
import AlertDialog from "@/components/AlertDialog.vue";
import { defineComponent, ref, computed, onMounted, onUnmounted, watch } from "vue";
import { useRoute } from "vue-router";
import { storeToRefs } from "pinia";
import { useI18n } from "vue-i18n";
import { format } from "date-fns";
import { useContentsStore } from "@/store/contents";
import { useCommonStore } from "@/store/common";
import ubistApi from "@/lib/ubistApi";
import PatternReport from "@/components/pattern/PatternReport.vue";
import menuData from "@/data/menuData.js";
import SearchContent from "@/containerss/SearchContent.vue";
import IconFavorites from "@/components/icon/IconFavorites.vue";
import IconRefresh from "@/components/icon/IconRefresh.vue";
import IconFolderAdd from "@/components/icon/IconFolderAdd.vue";
import IconSearch from "@/components/icon/IconSearch.vue";
import IconInfo from "@/components/icon/IconInfo.vue";
import IconArrowRight from "@/components/icon/IconArrowRight.vue";
import IconDelete from "@/components/icon/IconDelete.vue";
import EmptyText from "@/components/EmptyText.vue";
import IconSharing from "@/components/icon/IconSharing.vue";
import IconSharingOpen from "@/components/icon/IconSharingOpen.vue";
import IconMore from "@/components/icon/IconMore.vue";
import IconBlueFolder from "@/components/icon/IconBlueFolder.vue";
import IconBlueFolderOpen from "@/components/icon/IconBlueFolderOpen.vue";
import IconNormalFolder from "@/components/icon/IconNormalFolder.vue";
import IconNormalFolderOpen from "@/components/icon/IconNormalFolderOpen.vue";
import IconResultFold from "@/components/icon/IconResultFold.vue";
import IconSearchDelete from "@/components/icon/IconSearchDelete.vue";

import { VueDraggableNext } from "vue-draggable-next";
import { useFavoritesStore } from "@/store/favorites.js";
import FavoriteTree from "@/containerss/FavoriteTree.vue";
import FavoriteInput from "@/containerss/FavoriteInput.vue";

export default defineComponent({
  name: "Bookmark",
  emits: ["close", "changeSelectedFavorite", "hideButtonGroup", "updateModified"], // 발생시키는 이벤트들을 선언
  components: {
    IconSearchDelete,
    IconResultFold,
    IconBlueFolderOpen,
    IconNormalFolderOpen,
    IconNormalFolder,
    IconBlueFolder,
    IconMore,
    IconSharingOpen,
    IconSharing,
    EmptyText,
    IconDelete,
    IconArrowRight,
    IconInfo,
    FavoriteTree,
    IconSearch,
    IconFolderAdd,
    IconRefresh,
    IconFavorites,
    PatternReport,
    AlertDialog,
    SearchContent,
    draggable: VueDraggableNext,

    FavoriteInput,
  },
  props: {
    isCollapsed: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const route = useRoute();
    const brandId = ref(route.query.brandId);
    const drugId = ref(route.query.drugId);
    const name = ref(route.query.name);
    const englishName = ref(route.query.englishName);

    const menuName = "Bookmark";

    const { t } = useI18n();
    const commonStore = useCommonStore();
    const contentsStore = useContentsStore();
    const { isAlertDialogOpen, alertDialog, serviceList, customer } = storeToRefs(commonStore);
    const { loadingPattern, authToken } = storeToRefs(contentsStore);

    const {
      rows,
      columns,
      patternSelected,
      selectOptions,
      chooseOptions,
      // showContent,
    } = storeToRefs(contentsStore);

    const contents = ref([]);
    const isLoad = ref(false);
    const isAnalysisComplete = ref(false);
    const isScrollLoad = ref(false);

    const searchTextVal = ref("");
    const isSearch = ref(false);
    const activeTab = ref(0);

    const isFavoritesGuideTooltip = ref(false);
    const isResult = ref(false);
    const searchKeyword = ref("");

    const folderKeyId = ref(0); //폴더생성
    const isCreatingFolder = ref(false); //폴더생성 상태
    const showTooltip = ref(false); // 툴팁 표시 상태

    const favoriteId = ref(-1);

    const selectedBookmark = ref(null);
    const selectedFavorite = ref(null);

    const favoritesStore = useFavoritesStore();
    const {
      userId,
      favoriteData,
      favoriteList,
      openFolderIndexs,
      dragFavorite,
      overFavorite,
      changedFavoriteList,
      removeFavoriteList,
      searchFolderList,
      searchFavoriteList,
      contextMenu,
    } = storeToRefs(favoritesStore);
    const folders = ref([]);
    const bookmarks = ref([]);
    const loading = ref(false);

    // 폴더와 즐겨찾기 항목의 상태를 관리하는 변수
    const isTreeToggle = ref(false); // 폴더 열기/닫기 상태
    const isFolderMore = ref(false); // 폴더의 더보기 메뉴 열기/닫기 상태
    const isBookmarkMore = ref(false); // 즐겨찾기의 더보기 메뉴 열기/닫기 상태
    const selectedFolder = ref(null); // 선택된 폴더를 저장하는 변수
    const folderPath = ref([]); // 폴더 경로를 저장할 변수
    const hoveredBookmark = ref(null); // 북마크에 대한 마우스 오버 상태
    const cancelDisabled = ref(false);
    const isDeleting = ref(false);

    // 변경 여부를 계산하는 computed 속성
    const isModified = computed(() => changedFavoriteList.value.length > 0 || removeFavoriteList.value.length > 0);

    const handleDeleteClick = (favorite) => {
      isDeleting.value = true;
      deleteItemSelected(favorite);
      // 삭제 후 플래그 해제 (focusout 직전에 항상 true가 되도록)
      setTimeout(() => {
        isDeleting.value = false;
      }, 0);
    };

    watch(isModified, (newValue) => {
      emit("updateModified", newValue);
    });

    watch(
      () => cancelDisabled.value,
      (newVal) => {
        // console.log("cancelDisabled 상태 변화:", newVal);
      }
    );

    watch([favoriteId], () => {
      // console.log("watch favoriteId", favoriteId.value);
      if (favoriteId.value === -1) return;
    });

    onMounted(async () => {
      loadFetchFavorites(); // API 호출
      window.addEventListener("click", handleClickOutsideBookMark);
    });

    onUnmounted(() => {
      window.removeEventListener("click", handleClickOutsideBookMark);
      // console.log("onUnmounted");
    });

    // 모든제약사 하위폴더 확인용 (더보기버튼 안보이게하기위해)
    const isChildOfForbiddenFolder = (item, title = "모든 제약사") => {
      let current = item;
      while (current) {
        if (current.title === title) {
          return true;
        }
        current = current.parent;
      }
      return false;
    };

    // 마지막 즐겨찾기 요소를 가져오는 computed 속성
    const lastBookmark = computed(() => {
      const favorites = selectedFavorite.value?.children?.favorite || [];

      // console.log("favorites.length:", favorites.length);
      // console.log(
      //   "favorites[favorites.length - 1]:",
      //   favorites[favorites.length - 1]
      // );
      return favorites.length > 0 ? favorites[favorites.length - 1] : null;
    });

    // 즐겨찾기 리스트가 꽉 찬 상태인지 확인 (예시로 최대 10개로 설정)
    const isFullList = computed(() => {
      const maxVisibleBookmarks = 20; // 화면에 보일 수 있는 최대 즐겨찾기 수
      return selectedFavorite.value?.children?.favorite.length >= maxVisibleBookmarks;
    });

    //즐겨찾기 써머리  즐겨찾기 가리는것 처리 (handleMouseEnter , handleMouseLeave )
    const handleMouseEnter = async (bookmarkId) => {
      hoveredBookmark.value = bookmarkId;
    };

    const handleMouseLeave = () => {
      hoveredBookmark.value = null;
      // console.log("handleMouseLeave:", hoveredBookmark.value);
    };

    // 다른 곳 클릭 시 메뉴 닫기
    const handleClickOutsideBookMark = (event) => {
      const targetElement = event.target;
      if (targetElement && !targetElement.closest(".more-menu")) {
        isBookmarkMore.value = null;
      }
    };

    const changeSelectedFavorite = (favorite) => {
      //검색 폴더 리스트 초기화
      searchFavoriteList.value = null;

      //선택된즐겨찾기
      selectedFavorite.value = favorite;

      // 추가적으로 필요한 로직을 여기에 추가
      favoritesStore.hideContextMenuItem();
      emit("changeSelectedFavorite", favorite);
      emit("hideButtonGroup");

      const path = [];
      for (var parent = favorite; parent; parent = parent.parent) {
        if (parent.isFolder) {
          path.push(parent.title);
        }
      }
      path.reverse();
      folderPath.value = path;

      selectedBookmark.value = null; // ✔️ 기존 선택 즐겨찾기 해제
      // console.log("Selected folder:", favorite);
    };

    // 즐겨찾기 항목을 선택했을 때 처리
    const selectBookmark = (bookmark) => {
      selectedBookmark.value = bookmark;
      // console.log("Selected Bookmark:", bookmark);
    };

    const getMenuCode = (menuMap, name) => {
      let code = "";
      menuMap.forEach((menu) => {
        if (name === menu.name) {
          code = menu.code;
          return true;
        }
      });
      return code;
    };

    const getFavoriteIconName = (serviceCode) => {
      return favoritesStore.favoriteIconName(serviceCode);
    };

    const getFavoriteIconColor = (serviceCode) => {
      return { background: favoritesStore.favoriteIconColor(serviceCode) };
    };

    const menuCode = computed(() => {
      // const url = window.location.href;
      // const lastUrl = url.split("/").findLast(() => true);
      // const menu = menuData.find((menu) => menu.path === "/" + lastUrl);
      // return menu.code;

      const path = route.path; // e.g. "/Notice" or "/Archives"
      const menu = menuData.find((m) => m.path === path);
      return menu?.code ?? "";
    });

    const menuType = computed(() => {
      return _.find(serviceList.value, { code: menuCode.value })?.type ?? 0;
    });

    const isAside = computed(() => {
      return brandId.value === undefined && drugId.value === undefined;
    });

    // 폴더와 즐겨찾기 항목의 상태를 관리하는 변수
    const loadFetchFavorites = async () => {
      console.log("loadFetchFavorites call");

      try {
        loading.value = true;
        await favoritesStore.fetchFavorites(); // API 호출
        // console.log("✅ 즐겨찾기 데이터:", favoriteList.value);
        // await nextTick();

        const allFavorites = favoriteData.value[-1];
        folders.value.splice(0); // 배열 초기화
        bookmarks.value.splice(0);

        folders.value.push(...allFavorites.folder);
        bookmarks.value.push(...allFavorites.favorite);

        // await nextTick();

        // "내 즐겨찾기" 폴더를 찾아 기본 선택
        const myFavorites = folders.value.find((folder) => folder.title === t("label.favorite_rootFolder_my_favorite"));
        if (myFavorites) {
          changeSelectedFavorite(myFavorites);
        }

        inItOpenFolder(); // "내 즐겨찾기"만 열어두기
      } catch (error) {
        console.error("loadFetchFavorites error:", error);
      } finally {
        isSearch.value = false;
        searchFolderList.value = null;
        searchFavoriteList.value = null;
        loading.value = false;

        // 선택 초기화
        selectedBookmark.value = null;

        clearSearch();
      }
    };

    const inItOpenFolder = () => {
      // 모든 폴더 닫기
      openFolderIndexs.value = new Set();

      // "내 즐겨찾기" 폴더 찾기
      const myFavorites = folders.value.find((folder) => folder.title === t("label.favorite_rootFolder_my_favorite"));

      if (myFavorites) {
        // "내 즐겨찾기" 폴더만 열기
        openFolderIndexs.value.add(myFavorites.id);
        selectedFavorite.value = myFavorites;
      }
    };

    const toggleBookmarkMore = (bookmark) => {
      if (!bookmark.tempId) {
        isBookmarkMore.value = isBookmarkMore.value === bookmark.id ? null : bookmark.id;
      } else {
        isBookmarkMore.value = isBookmarkMore.value === bookmark.tempId ? null : bookmark.tempId;
      }

      selectedBookmark.value = null; // ✔️ 기존 선택 즐겨찾기 해제
    };

    const bookmarkDragStart = (e, selectBookmark) => {
      favoritesStore.hideContextMenuItem();
      emit("hideButtonGroup");
      dragFavorite.value = selectBookmark; // selectedFavorite을 selectedFolder로 변경
    };

    const bookmarkDragOver = (e, selectBookmark) => {
      e.preventDefault();

      // 드래그된 항목이 폴더이고 드롭 대상이 즐겨찾기인 경우 무시
      if (dragFavorite.value?.isFolder || selectBookmark.isFolder) {
        // console.log("[bookmarkDragOver]드래그 무시 (완료)");
        return;
      }

      // 드래그된 아이템과 드래그된 위치가 같으면 리턴
      if (dragFavorite.value === selectBookmark || overFavorite.value === selectBookmark) return;

      // 드래그된 아이템 또는 선택된 북마크가 없으면 리턴
      if (!dragFavorite.value || !selectBookmark) return;

      // 드래그된 북마크와 선택된 북마크가 다르면 선택된 북마크 위치를 저장
      overFavorite.value = selectBookmark;
    };

    const bookmarkDragLeave = (e, selectBookmark) => {
      e.preventDefault();
      // 폴더 관련 로직 제거
      // 드래그가 취소되거나 다른 곳으로 이동할 때 처리
      if (!dragFavorite.value.isFolder) {
        overFavorite.value = null; // 폴더 관련 로직 제거 후 즐겨찾기 처리
      }
    };

    const bookmarkDrop = (e, selectBookmark) => {
      e.preventDefault();

      // loading.value = true; // 로딩 상태를 true로 설정

      // 드래그된 항목이 폴더인 경우 드롭을 무시
      if (dragFavorite.value?.isFolder || selectBookmark.isFolder) {
        // console.log("(bookmarkDrop)드래그 무시 (완료)");
        overFavorite.value = null;
        dragFavorite.value = null;
        return;
      }

      if (dragFavorite.value === overFavorite.value) {
        overFavorite.value = null;
        dragFavorite.value = null;
        return;
      }
      const move = dragFavorite.value;
      const target = overFavorite.value;

      // 폴더는 드래그 대상에서 제외
      if (!move || !target || move.isFolder || target.isFolder) return;

      // 일반적인 즐겨찾기 이동 로직
      const type = "favorite"; // 즐겨찾기만 이동하므로 type을 고정

      if (!target.parent) {
        overFavorite.value = null;
        dragFavorite.value = null;
        return;
      }

      // 같은 이름을 가진 즐겨찾기 항목이 있는지 확인
      const sameFavorite = target.parent.children[type].find((f) => f.title === move.title);

      if (
        move.parentId !== target.parentId &&
        sameFavorite &&
        ((sameFavorite.id === null && move.id === null) || sameFavorite.id !== move.id)
      ) {
        commonStore.openAlertDialog({
          message: t("message.favorites_with_the_same_name_already_exists"),
          afterEvent: () => {
            moveFavorite(move, target);
            _.remove(target.parent.children[type], sameFavorite);
            _.remove(changedFavoriteList.value, sameFavorite);
            removeFavoriteList.value.push(sameFavorite);

            overFavorite.value = null;
            dragFavorite.value = null;
          },
          afterCancel: () => {
            overFavorite.value = null;
            dragFavorite.value = null;
          },
        });
        return;
      }

      moveFavorite(move, target);

      loading.value = false;
    };

    const moveFavorite = (move, target) => {
      if (move && !move.isFolder && target && !target.isFolder && target.parent && target.parent.children) {
        const type = "favorite"; // 즐겨찾기만 이동하므로 type을 "favorite"으로 고정

        // move 객체를 부모의 children 배열에서 제거
        _.remove(move.parent.children[type], move);

        // target 객체의 위치를 찾음
        let targetIndex = target.parent.children[type].indexOf(target);

        // 이동하려는 순서(사이에 놓을 시 아래쪽이 Target)의 Sequence 를 불러온다
        let targetSequence =
          targetIndex === -1 ? (_.last(target.parent.children[type])?.sequence ?? 0) + 1 : target.sequence;

        if (targetIndex === -1) {
          target.parent.children[type].push(move);
        } else {
          target.parent.children[type].splice(targetIndex, 0, move);
        }

        // 이동하려는 항목(move)의 순서를 이동하려는 순서(target)로 변경
        move.parentId = target.parent.id;
        move.parent = target.parent;
        move.sequence = targetSequence;

        if (changedFavoriteList.value.indexOf(move) === -1) {
          changedFavoriteList.value.push(move);
        } else {
          // 이미 변경 리스트에 있을 경우
          _.remove(changedFavoriteList.value, move); // 삭제
          changedFavoriteList.value.push(move); // 재 추가
        }

        // target 내 move보다 크거나 같은 순서의 항목은 모두 순서를 + i 해준다.
        target.parent.children[type]
          .filter((f) => f.sequence >= move.sequence)
          .forEach((f, i) => {
            if (f !== move) {
              f.sequence = move.sequence + i;
              if (changedFavoriteList.value.indexOf(f) === -1) {
                changedFavoriteList.value.push(f);
              }
            }
          });

        overFavorite.value = null;
        dragFavorite.value = null;
      } else {
        console.error("move 또는 target 객체가 유효하지 않거나 부모나 children 속성이 정의되지 않았습니다.");
      }
    };

    // 즐겨찾기 폴더 추가
    const onClickAddFolder = () => {
      if (!selectedFavorite.value || !selectedFavorite.value.isFolder) {
        commonStore.openAlertDialog({
          message: t("대상폴더를 선택하지 않았습니다 (NULL)"),
        });
        return;
      }

      const parent = selectedFavorite.value.isFolder
        ? selectedFavorite.value
        : favoriteList.value.find((f) => f.id === selectedFavorite.value.parentId);

      if (parent.isAppFavorite) {
        commonStore.openAlertDialog({
          message: t("message.favorites_cannot_add_folder"),
        });
        return;
      }

      if (!parent.children) {
        parent.children = { folder: [], favorite: [] };
      }

      folderKeyId.value = folderKeyId.value - 10; // 생성할 때마다 -10 (-1로하면 기존 상위메인폴더랑 겹칠수있음)

      const sequence =
        parent.children.folder[parent.children.folder.length - 1] === undefined
          ? 1
          : parent.children.folder[parent.children.folder.length - 1].sequence;

      const favorite = {
        id: folderKeyId.value,
        parentId: parent.id,
        title: "",
        isFolder: true,
        type: 0,
        children: { folder: [], favorite: [] },
        sequence: sequence,
        parent: parent,
        isEdit: true,
        productType: localStorage.getItem("productType"),
      };
      parent.children.folder.push(favorite);
      changedFavoriteList.value.push(favorite);

      openFolderIndexs.value.add(parent.id);

      isCreatingFolder.value = true; //상태값
      showTooltip.value = false; // 폴더 생성 시 툴팁 숨기기
    };

    // 즐겨찾기 추가
    const onClickAddFavorite = async () => {
      // 즐겨찾기 추가 후, more 메뉴가 열리지 않도록 초기화
      isBookmarkMore.value = null;

      if (!menuCode.value || menuType.value === 0) return;

      if (!selectedFavorite.value || !selectedFavorite.value.isFolder) {
        commonStore.openAlertDialog({
          message: t("저장위치가 지정되지않았습니다. "),
        });
        return;
      }

      const parent = selectedFavorite.value.isFolder
        ? selectedFavorite.value
        : favoriteList.value.find((f) => f.id === selectedFavorite.value.parentId);

      if (parent.isAppFavorite) {
        commonStore.openAlertDialog({
          message: t("message.favorites_cannot_add_favorite"),
        });
        return;
      }

      if (!parent.children) {
        parent.children = { folder: [], favorite: [] };
      }

      const lastSeq =
        parent.children.favorite.length > 0
          ? _.last(parent.children.favorite).sequence + 1
          : parent.children.favorite.length + 1;

      const favorite = {
        id: null,
        parentId: parent.id,
        serviceCode: menuCode.value,
        title: "",
        isFolder: false,
        children: { folder: [], favorite: [] },
        // sequence: parent.children.favorite.length + 1,
        sequence: lastSeq,
        parent: parent,
        isEdit: true,
      };

      if (menuType.value === 1) {
        const validation = await contentsStore.onClickReportValidation(
          menuCode.value,
          commonStore.openAlertDialog,
          null,
          "save"
        );
        if (!validation) return;

        favorite.type = 1;
        favorite.payload = JSON.stringify({
          rows: rows.value,
          columns: columns.value,
          options: selectOptions.value,
          chooseOptions: chooseOptions.value,
        });
      } else {
        const validation = await contentsStore.onClickPatternValidation(
          menuCode.value,
          commonStore.openAlertDialog,
          null,
          "save"
        );
        if (!validation) return;

        favorite.type = 2;
        favorite.payload = JSON.stringify(patternSelected.value);
      }

      parent.children.favorite.push(favorite);
      changedFavoriteList.value.push(favorite);

      openFolderIndexs.value.add(parent.id);
    };

    // 전체 즐겨찾기 및 폴더를 검색어에 따라 필터링
    const filteredFavorites = computed(() => {
      if (!searchKeyword.value) return bookmarks.value; // 검색어가 없으면 전체 목록 반환
      const keyword = searchKeyword.value.toLowerCase();
      return bookmarks.value.filter(
        (f) => f.name?.toLowerCase().includes(keyword) // name이 존재할 경우에만 toLowerCase 호출
      );
    });

    const filteredFolders = computed(() => {
      if (!searchKeyword.value) return folders.value;
      const keyword = searchKeyword.value.toLowerCase();
      return folders.value.filter(
        (f) => f.name?.toLowerCase().includes(keyword) // name이 존재할 경우에만 toLowerCase 호출
      );
    });

    const selectedFolderFavorites = computed(() => {
      if (!selectedFolder.value) return [];
      return favorites.value.filter((favorite) => favorite.path.includes(selectedFolder.value.name));
    });

    // X 버튼 클릭 시 검색어 초기화
    const clearSearch = () => {
      searchKeyword.value = "";
      // console.log("clearSearch:");
    };

    // 폴더 선택 시 선택된 폴더의 즐겨찾기 출력
    const selectFolder = (folder) => {
      // console.log("선택된 폴더:", folder);
    };

    const searchFavorite = () => {
      selectedFavorite.value = null;
      openFolderIndexs.value = new Set([0]); //폴더 열기상태
      isSearch.value = true;
      if (searchKeyword.value === "") {
        folderPath.value = null; //상단 폴더 경로
        openFolderIndexs.value = new Set(); // 모든열려있는폴더 닫기
        loadFetchFavorites(); // API 호출
        return;
      }

      searchFolderList.value = new Set([]);
      searchFavoriteList.value = new Set([]);
      // folderList.value = new Set([]);

      const listFolder = favoriteList.value.filter((f) => f.title && f.title.includes(searchKeyword.value));
      const listFavorite = favoriteList.value.filter(
        (f) => !f.isFolder && f.title && f.title.includes(searchKeyword.value)
      );

      listFavorite.forEach((f) => {
        const path = [];
        for (var parent = f.parent; parent; parent = parent.parent) {
          if (parent.isFolder) {
            path.push(parent.title);
          }
        }

        path.reverse();
        f.path = path;
        searchFavoriteList.value.add(f);
      });

      listFolder.forEach((f) => {
        searchFolderList.value.add(f);

        if (f.isFolder) {
          // folderList.value.add(f); // 폴더를 따로 저장
          f.children?.folder.forEach((f) => searchFolderList.value.add(f));
        }

        const stack = [];
        stack.push(f.parent);
        while (stack.length > 0) {
          const favorite = stack.pop();

          searchFolderList.value.add(favorite);
          if (favorite?.isFolder) {
            // folderList.value.add(favorite); // 부모 폴더 추가
            openFolderIndexs.value.add(favorite.id);
          }

          if (favorite?.parent) {
            stack.push(favorite.parent);
          }
        }
      });
    };

    const onClickOpenInNewTab = (favorite) => {
      // id가 null이거나 -1인 경우 (아직 저장되지 않은 즐겨찾기)
      if (favorite.id === null || favorite.id < 0) {
        commonStore.openAlertDialog({
          title: "",
          message: t("message.favorite_saveRequired"),
          afterEvent: () => {},
        });

        return;
      }

      const url = `/Favorite?favoriteId=${favorite.id}`;
      window.open(url, "_blank");
    };

    const deleteItemSelected = (favorite) => {
      const type = favorite.isFolder ? "folder" : "favorite";

      // 임시 추가된 즐겨찾기라면 바로 뷰에서만 제거하고 저장 로직 방지
      if (!favorite.isFolder && (favorite.id === null || favorite.id < 0)) {
        _.remove(favorite.parent.children[type], (f) => f === favorite);
        _.remove(changedFavoriteList.value, (f) => f === favorite);
        return;
      }

      if (type == "folder") {
        isAlertDialogOpen.value = true;
        alertDialog.value = {
          maxWidthOption: "",
          title: "",
          message: t("message.favorites_folder_delete", {
            name: favorite.title,
          }),
          afterEvent: async () => {
            removeFavoriteList.value.push(favorite);

            _.remove(favorite.parent.children[type], favorite);
            _.remove(changedFavoriteList.value, favorite);

            contextMenu.value = {
              isShow: false,
              position: { x: 0, y: 0 },
              id: null,
              isFolder: false,
            };
          },
          afterCancel: () => {},
        };
      } else {
        isAlertDialogOpen.value = true;
        alertDialog.value = {
          maxWidthOption: "",
          title: "",
          message: t("message.favorites_delete", { name: favorite.title }),
          afterEvent: async () => {
            removeFavoriteList.value.push(favorite);

            _.remove(favorite.parent.children[type], favorite);
            _.remove(changedFavoriteList.value, favorite);
          },
          afterCancel: () => {},
        };
      }
    };

    const onClickAddModify = (favorite) => {
      favorite.isEdit = true;
      contextMenu.value = {
        isShow: false,
        position: { x: 0, y: 0 },
        id: null,
        isFolder: false,
      };
    };

    const close = async () => {
      // selectedFavorite.value = favoriteData.value[-1];
      // openFolderIndexs.value = new Set([0]);
      // await favoritesStore.fetchFavorites();
      loading.value = false;
    };

    const onCancel = () => {
      // console.log(" onCancel");

      const length = changedFavoriteList.value.length + removeFavoriteList.value.length;
      if (length > 0) {
        commonStore.openAlertDialog({
          message:
            // "저장을 하지 않고 현재 창을 닫게 되면 변경사항이 저장되지 않습니다.\n정말 닫으시겠습니까?",
            t("message.modify_favorite_cancel"),
          afterEvent: () => {
            // console.log("1emit close 호출됨");
            emit("close");
          },
          afterCancel: () => {},
        });
        return;
      }

      // console.log("2emit close 호출됨");
      emit("close");
    };

    const onSave = async () => {
      try {
        loading.value = true;

        let isEmptyContent = false;
        if (
          selectedBookmark.value &&
          (changedFavoriteList.value.length === 0 || removeFavoriteList.value.length === 0)
        ) {
          isEmptyContent =
            (menuType.value === 1 && (rows.value.length === 0 || columns.value.length === 0)) ||
            (menuType.value === 2 && !patternSelected.value?.length);

          if (isEmptyContent) {
            commonStore.openAlertDialog({
              message: t("message.favorites_no_content_save"), // "저장할 컨텐츠가 없습니다."
              afterEvent: () => {
                loading.value = false;
              },
            });
            return;
          }
        }

        const hasChanges =
          changedFavoriteList.value.length > 0 ||
          removeFavoriteList.value.length > 0 ||
          selectedBookmark.value !== null;

        if (!hasChanges) {
          commonStore.openAlertDialog({
            message: t("message.favorites_noChange_exit"),
            afterEvent: () => {
              loading.value = false;
            },
          });
          return;
        }

        // 메인 메뉴 코드 목록 (메인, 공지, 자료실, 공백(menuData에없는것들))
        const MAIN_MENU_CODES = ["main", "S020", "S021", ""];
        const isMainMenu = computed(() => MAIN_MENU_CODES.includes(menuCode.value));

        // 선택된 즐겨찾기가 삭제 대상에 포함됐는지 확인
        const isSelectedBookmarkRemoved = removeFavoriteList.value.some((f) => f.id === selectedBookmark.value?.id);

        // 덮어쓰기 시도 판단: 선택은 했지만 수정/추가 없이 저장만 누름
        const isTryingToOverwrite =
          selectedBookmark.value !== null &&
          changedFavoriteList.value.length === 0 &&
          removeFavoriteList.value.length === 0 &&
          !isSelectedBookmarkRemoved;

        // 메인 메뉴에서 덮어쓰기 시도 시 저장 차단
        if (isMainMenu.value && isTryingToOverwrite) {
          commonStore.openAlertDialog({
            message: t("message.favorites_main_not_Overwriting"), // "메인에서는 즐겨찾기를 덮어쓸 수 없습니다."
            afterEvent: () => {
              loading.value = false;
            },
          });
          return;
        }

        let isEmpty = false;
        changedFavoriteList.value.forEach((changedFavorite) => {
          if (isEmpty) return;
          if (changedFavorite.title.trim() === "") {
            const messageKey = changedFavorite.isFolder ? "message.input_folder_name" : "message.input_favorite_name";

            commonStore.openAlertDialog({
              message: t(messageKey),
              afterEvent: () => {},
              afterCancel: null,
            });

            isEmpty = true;
            loading.value = false;
            return;
          }
        });
        if (isEmpty) return;

        if (
          selectedBookmark.value &&
          selectedBookmark.value.id !== null &&
          changedFavoriteList.value.length === 0 &&
          removeFavoriteList.value.length === 0
        ) {
          commonStore.openAlertDialog({
            message: t("message.favorites_overwrite_selected_favorite"), //선택한 즐겨찾기에 덮어쓰시겠습니까?
            afterEvent: async () => {
              loading.value = true;

              const parentNode = selectedBookmark.value.parent;
              const type = selectedBookmark.value.isFolder ? "folder" : "favorite";

              // 기존 동일 이름 즐겨찾기 제거 (title 기준 중복 방지)
              const sameFavorite = parentNode.children[type].find(
                (f) => f.title === selectedBookmark.value.title && f.id !== selectedBookmark.value.id
              );

              if (sameFavorite) {
                _.remove(parentNode.children[type], (f) => f.id === sameFavorite.id);
                _.remove(changedFavoriteList.value, (f) => f.id === sameFavorite.id);
                removeFavoriteList.value.push(sameFavorite);
              }

              // 선택된 즐겨찾기 자체도 제거
              const existing = parentNode.children[type].find((f) => f.id === selectedBookmark.value.id);
              if (existing) {
                _.remove(parentNode.children[type], (f) => f.id === existing.id);
                removeFavoriteList.value.push(existing);
              }

              // 새로운 즐겨찾기 항목 추가 (같은 title, 위치, 새로운 payload)
              const newFavorite = {
                id: null, // 새로 생성되도록
                parentId: selectedBookmark.value.parentId,
                serviceCode: menuCode.value,
                title: selectedBookmark.value.title,
                isFolder: false,
                children: { folder: [], favorite: [] },
                sequence: selectedBookmark.value.sequence,
                parent: parentNode,
                isEdit: false,
                type: menuType.value,
                payload:
                  menuType.value === 1
                    ? JSON.stringify({
                        rows: rows.value,
                        columns: columns.value,
                        options: selectOptions.value,
                        chooseOptions: chooseOptions.value,
                      })
                    : JSON.stringify(patternSelected.value),
                overview: "", // 필요 시 채움
              };

              // 화면과 저장 대상으로 추가
              parentNode.children[type].push(newFavorite);
              changedFavoriteList.value.push(newFavorite);

              // 선택 초기화
              selectedBookmark.value = null;

              await proceedToSave();
            },
            afterCancel: () => {
              loading.value = false;
            },
          });
          return;
        }

        await proceedToSave();
      } catch (error) {
        console.error("Error while processing favorites:", error);
      } finally {
        loading.value = false;
      }
    };

    const proceedToSave = async () => {
      try {
        loading.value = true;
        cancelDisabled.value = true;

        const productType = localStorage.getItem("productType");
        const removeIds = removeFavoriteList.value.filter((f) => f.id).map((f) => f.id);

        const addFolders = changedFavoriteList.value.filter((f) => f.isFolder && f.id < 0);
        const addFavorites = changedFavoriteList.value.filter((f) => !f.isFolder && (f.id === null || f.id < 0));
        const changeFavorites = changedFavoriteList.value.filter((f) => f.id !== null && f.id > 0);

        // 삭제
        await Promise.all(removeIds.map((id) => favoritesStore.deleteFavorite(id)));

        // 폴더 추가
        for (const folder of addFolders) {
          const parentFolder = addFolders.find((f) => f.id === folder.parentId);
          if (parentFolder && parentFolder.newId !== undefined) {
            folder.parentId = parentFolder.newId;
          }

          const data = {
            ...folder,
            id: 0,
            userId: userId.value,
            children: undefined,
            parent: undefined,
          };

          const response = await ubistApi.postFavorite(productType, data);
          const parentId = response.data.id;
          folder.newId = parentId;

          folder.children.folder.forEach((f) => (f.parentId = parentId));
          folder.children.favorite.forEach((f) => (f.parentId = parentId));
        }

        // 즐겨찾기 추가
        await Promise.all(
          addFavorites.map((favorite) => {
            const data = {
              ...favorite,
              id: 0,
              userId: userId.value,
              payload: favorite.payload,
              children: undefined,
              parent: undefined,
              overview: favorite.overview,
              originalId: favorite.originalId,
            };
            return ubistApi.postFavorite(productType, data);
          })
        );

        // 즐겨찾기 수정
        await Promise.all(
          changeFavorites.map((favorite) => {
            const data = {
              ...favorite,
              userId: userId.value,
              payload: favorite.payload,
              children: undefined,
              parent: undefined,
            };
            return ubistApi.putFavorite(productType, data);
          })
        );

        // 정리
        await ubistApi.cleanUpFavorite();

        // UI 상태 초기화
        await loadFetchFavorites();
        await nextTick();
        // close();

        console.log("즐겨찾기 저장 완료 및 초기화");
      } catch (error) {
        console.error("proceedToSave error:", error);
      } finally {
        loading.value = false;
        cancelDisabled.value = false;
      }
    };

    return {
      t,
      isAside, //상단
      isTreeToggle,
      contents,
      patternSelected,
      isFolderMore,
      isBookmarkMore,
      isLoad,
      isAnalysisComplete,
      isScrollLoad,
      searchTextVal,
      isSearch,
      searchKeyword,
      activeTab,
      isFavoritesGuideTooltip,
      isResult,
      parentMenuCode: getMenuCode(menuData, menuName),

      folders,
      toggleBookmarkMore,
      bookmarks,
      loading,
      loadFetchFavorites, // 새로고침 버튼에 사용
      favoriteId,
      favoriteData,
      selectedFavorite,
      changeSelectedFavorite,
      menuType,

      dragFavorite,
      overFavorite,

      bookmarkDragStart,
      bookmarkDragOver,
      bookmarkDragLeave,
      bookmarkDrop,

      selectBookmark,

      onClickAddFolder, //즐겨찾기 폴더 추가
      onClickAddFavorite, //즐겨찾기 추가

      getFavoriteIconColor,
      getFavoriteIconName,

      filteredFavorites,
      filteredFolders,
      selectedFolder,
      selectedFolderFavorites,
      clearSearch,
      selectFolder,

      searchFavorite,
      searchFolderList,
      searchFavoriteList,

      folderPath,
      contextMenu,

      selectedBookmark,
      onClickOpenInNewTab,
      deleteItemSelected,
      onClickAddModify,

      onCancel,
      onSave,

      handleMouseEnter,
      handleMouseLeave,
      hoveredBookmark,

      isChildOfForbiddenFolder,
      lastBookmark,
      isFullList,
      isModified,

      cancelDisabled,
      handleDeleteClick,
    };
  },
  async created() {},
});
</script>

<style scoped>
.favorites {
  display: flex;
  flex-direction: column;

  height: 100%;
  max-height: 100%;
}

.favorites-title {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  height: 41px;
  margin-bottom: 12px;
  padding: 20px 24px 32px;
}

.favorites-title .title {
  font-size: 18px;
  font-weight: 700;
  line-height: 25px;
  text-align: left;
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;
}

.favorites-title .title span {
  vertical-align: top;
}

.favorites-title .title span + span {
  margin-left: 5px;
}

.favorites-title .title .btn-refresh {
  width: 20px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.favorites-title .title .btn-refresh i {
  width: 20px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.favorites-header {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px 0;
}

.favorites-header .flex-l {
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
}

.favorites-header .flex-l button {
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
  /* 157.143% */
  letter-spacing: -0.28px;
  padding: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 140px;
}

.favorites-header .flex-l button.btn-fold-add {
  color: #174fdc;
  border: 1px solid #174fdc;
}

.favorites-header .flex-l button.btn-favorite-add {
  color: #343434;
  border: 1px solid #dddddd;
}

.favorites-header .flex-l button i {
  margin-right: 4px;
}

.favorites-header .flex-l button.btn-favorite-add i {
  width: 18px !important;
}

.favorites-header .search-wrap {
  position: relative;
}

.favorites-header .search-wrap input {
  padding-right: 38px;
}

.favorites-header .search-wrap input:focus {
  border: 1px solid #222222;
}

.favorites-header .search-wrap .btn-search {
  width: 20px;
  height: 20px;
  position: absolute;
  display: block;
  right: 14px;
  top: 5px;
}

.favorites-header .search-wrap .btn-search-delete {
  width: 20px;
  height: 20px;
  position: absolute;
  display: block;
  right: 12px;
  top: 5px;
}

.search-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.favorites-header .btn-group {
  display: flex;
  align-items: center;
  gap: 10px;
}

.favorites-header .btn-group .btn.unfold {
  display: flex;
  align-items: center;
  padding: 0 8px 0 12px;
  border-radius: 28px;
  overflow: hidden;
}

.favorites-header .btn-group .btn.unfold span {
  font-size: 16px;
  color: #b8b8b8;
  margin-left: 8px;
}

.favorites-header .btn,
.favorites-header .search-group > input {
  height: 28px;
}

.favorites-header .btn-group .btn2 {
  height: 24px;
  width: 24px;
  padding: 3px;
}

.favorites-header .btn-group .btn2:disabled {
  background-color: #ebebeb;
}

.me-search {
  position: absolute;
  width: 810px;
  margin-top: 10px;
  padding: 10px 15px 10px 15px;
  z-index: 1;
}

.aside-collapsed {
  position: absolute;
  border: var(--border-line);
  background-color: #fff;
  box-shadow: -4px 6px 12px rgba(6, 10, 19, 0.2);
}

.me-title {
  display: flex;
  align-items: center;
  margin: 20px 0 10px;
}

.me-title h4 {
  font-size: 16px;
  font-weight: 700;
  margin-right: 10px;
}

.me-tab {
  display: flex;
}

.me-tab > div {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1 0;
  padding: 3px 0;
  background-color: #fff;
  border: var(--border-line);
  border-left-width: 0;
  font-size: 13px;
  font-weight: 500;
  /* 20230619 추가 */
  cursor: pointer;
  text-align: center;
  transition: all 0.1s ease-in;
}

.me-tab > div:first-child {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  border-left-width: 1px;
}

.me-tab > div:last-child {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.me-tab > div:hover {
  background-color: #f5f5f5;
}

.me-tab > div.active,
.me-tab > div.active:hover {
  border-color: var(--primary-color);
  background-color: var(--primary-color);
  color: #fff;
}

.favorites-body {
  flex: 1 1 auto;
  overflow-y: hidden;
}

.favorites-body2 {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 180px;
}

.favorites-body2 h1 {
  padding-top: 16px;
  padding-bottom: 8px;
  font-size: 18px;
  font-weight: 700;
  line-height: 25px;
  color: #333;
}

.favorites-body2 h2 {
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  color: #666;
}

.me-loading {
  position: relative;
  height: 100%;
  width: 100%;

  background-color: #fff;
}

.me-table {
  overflow: visible;
  height: 91%;
}

.me-table .tit {
  position: relative;
  display: inline-block;
  font-size: 15px;
  font-weight: 700;
  padding-left: 12px;
}

.me-table .tit::before {
  position: absolute;
  left: 0;
  top: 50%;
  content: "";
  width: 5px;
  height: 5px;
  background-color: #ccc;
  border-radius: 50%;
  transform: translateY(-50%);
}

.me-table table {
  border-top: 2px solid #000;
  border-bottom: 1px solid #e9e9e9;
  font-size: 13px;
  line-height: 1.4;
}

.me-table table th {
  text-align: center;
  vertical-align: middle;
  font-weight: 500;
  color: #000;
  background-color: #f5f5f5;
  padding: 7px 20px;
  border-top: 1px solid #e9e9e9;
  border-right: 1px solid #e9e9e9;
}

.me-table table td {
  vertical-align: middle;
  padding: 7px 20px;
  border-top: 1px solid #e9e9e9;
  white-space: normal;
  color: var(--font-sec-color);
}

.search-content {
  display: flex;
  flex: 1 1 auto;
  min-height: 150px;
}

.search-content-sub {
  flex: 1 1 auto;
  width: 100%;
}

.search-content-sub + .search-content-sub {
  margin-left: 5px;
}

.selected {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.selected .header {
  display: flex;
  align-items: center;
  height: fit-content;
  padding: 4px 16px;
  background-color: #f5f5f5;
  border: var(--border-line);
  border-bottom: 0;
  font-size: 15px;
  font-weight: 700;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;

  /* 목록 펼치고 접기 0623 */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.selected .header > span {
  display: inline-block;
  margin-left: 4px;
}

.selected .header > span.material-symbols-outlined {
  font-size: 26px;
  color: #b9b9b9;
}

.selected select {
  flex: 1 1 auto;
  max-width: 100%;
  width: 100%;
  padding: 12px;
  border: var(--border-line);
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
}

.selected select:focus {
  /* border: 1px solid #999; */
  outline: none;
}

.selected select option {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
  padding: 4px 6px;
  margin: 1px 0;
}

.selected select option:checked {
  border-radius: 4px;
  background: #e1e8f6 linear-gradient(0deg, #e1e8f6 0%, #e1e8f6 100%);
}

/* 로딩바 */
.loading-overlay {
  z-index: 99999;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  /* 로딩바 배경색 */
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading-overlay img {
  width: 70px;
  /* 로딩바 이미지 크기 */
  height: 70px;
  animation: spin 2s infinite linear;
  /* 로딩바 애니메이션 설정 */
}

@keyframes spin {
  from {
    transform: rotate(0deg);
    /* 로딩바 초기 각도 */
  }

  to {
    transform: rotate(360deg);
    /* 로딩바 회전 각도 */
  }
}
</style>
<style lang="scss">
@import "@/assets/css/bookmark.scss";
</style>
